import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';

// Configuration de la base URL pour les requêtes API
// Ne pas inclure /api ici car les composants l'ajoutent déjà
window.axios.defaults.baseURL = '';

// Support pour les cookies (Sanctum)
window.axios.defaults.withCredentials = true;

// Intercepteur global pour gérer les erreurs
window.axios.interceptors.response.use(
    response => response,
    error => {
        const status = error.response ? error.response.status : null;
        const url = error.config?.url || '';

        // Ne pas rediriger si c'est un logout
        if (url.includes('/api/logout')) {
            return Promise.reject(error);
        }

        if (status === 403) {
            // Ne pas rediriger si c'est une vérification de permission qui devrait être gérée localement
            // Mais pour une application globale, souvent on veut rediriger ou montrer un toast
            if (!url.includes('/api/user')) { // Exemple d'exception si nécessaire
                // Nous pouvons utiliser window.location ou router si disponible, 
                // mais ici nous sommes dans bootstrap.js, router n'est pas encore monté.
                // Le router.js gère déjà les redirections de navigation.
                // Pour les appels API, nous pouvons soit laisser le composant gérer, 
                // soit émettre un événement, soit rediriger "brutalement".
                // Pour l'instant, laissons les composants gérer ou le router guard faire son travail pour la navigation.
                // Cependant, pour les "spectacular error pages", si l'API renvoie 500, on veut probablement rediriger.
            }
        }

        if (status === 401) {
            // Unauthenticated - session expired or token revoked
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            delete window.axios.defaults.headers.common['Authorization'];

            // Si we are not already on login page, redirect
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        if (status === 500 || status === 503) {
            window.location.href = '/error/500';
        }

        return Promise.reject(error);
    }
);
